import React, { useEffect, useState } from 'react';
import { KeyTurnMark } from './KeyTurnMark';
import { navLinks, signInUrl } from '../data/site';
export function SiteHeader() {
  const [lifted, setLifted] = useState(false);
  useEffect(() => {
    const onScroll = () => setLifted(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full border-b transition-colors duration-200 ease-smooth ${lifted ? 'border-line bg-cream/95 backdrop-blur' : 'border-transparent bg-cream'}`} data-id="element-295" data-mp="uyipo3qb7gtk">
      <div className="mx-auto flex h-[72px] max-w-[1180px] items-center justify-between px-4 sm:px-8" data-id="element-296" data-mp="14u293qnosn1f">
        <a href="#top" className="flex items-center gap-2 sm:gap-2.5" aria-label="KeyTurn home" data-id="element-297" data-mp="zzokq87fzg69">
          <span className="flex h-8 w-8 items-center justify-center rounded-xl bg-charcoal-700 sm:h-9 sm:w-9" data-id="element-298" data-mp="2gdet3r5lgqlp">
            <KeyTurnMark size={17} data-id="element-299" data-mp="29jtw2kh9maho" />
          </span>
          <span className="font-display text-[17px] font-semibold tracking-[-0.02em] text-charcoal-700 sm:text-[19px]" data-id="element-300" data-mp="29jafb73cps58">
            KeyTurn
          </span>
        </a>

        <nav aria-label="Sections" className="hidden items-center gap-6 lg:flex" data-id="element-301" data-mp="2jhq7lde477gb">
          {navLinks.map(link => <a key={link.href} href={link.href} className="whitespace-nowrap text-[13px] font-medium text-charcoal-500 transition-colors duration-150 ease-smooth hover:text-charcoal-700" data-id="element-302" data-mp="2ofrs82r6vetw">
              {link.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-1.5 sm:gap-4" data-id="element-303" data-mp="20pxhpruce2ct">
          <a href="#story" className="hidden whitespace-nowrap text-[13px] font-medium text-charcoal-500 transition-colors duration-150 ease-smooth hover:text-charcoal-700 lg:block" data-id="element-304" data-mp="25igs6fxqghde">
            See how it works
          </a>
          <a href={signInUrl} className="whitespace-nowrap rounded-lg border border-charcoal-200 px-2.5 py-2 text-[12.5px] font-semibold text-charcoal-700 transition-[border-color,transform] duration-150 ease-smooth hover:border-charcoal-400 active:scale-[0.98] sm:px-4 sm:py-2.5 sm:text-[13px]" data-id="element-305" data-mp="1czkxbhhwud5c">
            Sign in
          </a>
          <a href="#demo" className="whitespace-nowrap rounded-lg bg-charcoal-700 px-2.5 py-2 text-[12.5px] font-semibold text-cream transition-[background-color,transform] duration-150 ease-smooth hover:bg-charcoal-600 active:scale-[0.98] sm:px-4 sm:py-2.5 sm:text-[13px]" data-id="element-306" data-mp="19t9hw0y594qs">
            <span className="sm:hidden" data-id="element-307" data-mp="w1uw5mcuqpg1">Book demo</span>
            <span className="hidden sm:inline" data-id="element-308" data-mp="r0xc148a7lbw">Book a demonstration</span>
          </a>
        </div>
      </div>
    </header>;
}